const pageNameKey = "filterIcon";

export const filterIconEn = {
  [pageNameKey]: {
    tooltip: "Filter Data Points",
    clearButtonTooltip: "Clear Filter",
    clearButtonText: "Clear",
  },
};

export const filterIconPtBr = {
  [pageNameKey]: {
    tooltip: "Filtrar pontos de dados",
    clearButtonTooltip: "Limpar filtro",
    clearButtonText: "Limpar",
  },
};

export const filterIconDe = {
  [pageNameKey]: {
    tooltip: "Filter Datenpunkte",
    clearButtonTooltip: "Filter zurücksetzen",
    clearButtonText: "Zurücksetzen",
  },
};

export const filterIconZhHans = {
  [pageNameKey]: {
    tooltip: "过滤数据点",
    clearButtonTooltip: "清除过滤器",
    clearButtonText: "清除",
  },
};

export const filterIconIt = {
  [pageNameKey]: {
    tooltip: "Filtra nodi",
    clearButtonTooltip: "Rimuovi filtro",
    clearButtonText: "Annulla",
  },
};

export const filterIconEs = {
  [pageNameKey]: {
    tooltip: "Filtrar puntos de datos",
    clearButtonTooltip: "Borrar filtro",
    clearButtonText: "Borrar",
  },
};

export const filterIconNl = {
  [pageNameKey]: {
    clearButtonText: "Resetten",
    clearButtonTooltip: "Filter resetten",
    tooltip: "Gegevenspunten filteren",
  },
};

export const filterIconTr = {
  [pageNameKey]: {
    clearButtonText: "Temizlemek",
    clearButtonTooltip: "Filtreyi Temizle",
    tooltip: "Veri Noktalarını Filtrele",
  },
};
